import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
});

const TextSearch = (props) => {
  return (
    null
  );
}

export default TextSearch;


// WEBPACK FOOTER //
// ./src/nomad/TextSearch.jsx